import script from "./ValueTags.vue?vue&type=script&setup=true&lang=js"
export * from "./ValueTags.vue?vue&type=script&setup=true&lang=js"

import "./ValueTags.vue?vue&type=style&index=0&id=6110c4c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6110c4c2"]])

export default __exports__